import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { SidenavModel } from "../../models/sidenav.model";
import { SvgIconComponent } from "@app/kernel/tools/svg-icon/components/svg-icon/svg-icon.component";
import { TranslatePipe } from "@ngx-translate/core";
import { JsonPipe, NgTemplateOutlet } from "@angular/common";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { expandNavItemAnimation } from "../../animations/expand-nav-item.animation";

@Component({
  selector: "app-links-nav",
  imports: [SvgIconComponent, TranslatePipe, NgTemplateOutlet, JsonPipe, RouterLink, RouterLinkActive],
  templateUrl: "./links-nav.component.html",
  styleUrl: "./links-nav.component.scss",
  animations: [expandNavItemAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "links-nav",
  },
})
export class LinksNavComponent {
  selectedMainItem = input.required<SidenavModel>();
  selectItem = output<SidenavModel>();

  clickItem(item: SidenavModel) {
    this.selectItem.emit(item);
  }
}
